import React from 'react';
import { Box, Grid, TextField, Button } from '@mui/material';

const EtcForm = ({ formik }) => {
  return (
    <div>
      <Box
        component="form"
        sx={{
          display: 'flex',
          flexDirection: 'column',
          marginBottom: 2,
          px: 1,
        }}
        noValidate
        autoComplete="off"
        onSubmit={formik.handleSubmit}
      >
        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          spacing={1}
        >
          <Grid item xs>
            <TextField
              margin="normal"
              variant="outlined"
              fullWidth
              id="attrVal1"
              name="attrVal1"
              label="기타사항명"
              value={formik.values.attrVal1}
              onChange={formik.handleChange}
              error={formik.touched.attrVal1 && Boolean(formik.errors.attrVal1)}
              helperText={formik.touched.attrVal1 && formik.errors.attrVal1}
            />
          </Grid>
          <Grid item xs>
            <TextField
              margin="normal"
              variant="outlined"
              fullWidth
              id="attrVal2"
              name="attrVal2"
              label="기타사항데이터"
              value={formik.values.attrVal2}
              onChange={formik.handleChange}
              error={formik.touched.attrVal2 && Boolean(formik.errors.attrVal2)}
              helperText={formik.touched.attrVal2 && formik.errors.attrVal2}
            />
          </Grid>
          <Grid item xs>
            <TextField
              margin="normal"
              variant="outlined"
              fullWidth
              id="attrVal3"
              name="attrVal3"
              label="기타사항 설명"
              value={formik.values.attrVal3}
              onChange={formik.handleChange}
              error={formik.touched.attrVal3 && Boolean(formik.errors.attrVal3)}
              helperText={formik.touched.attrVal3 && formik.errors.attrVal3}
            />
          </Grid>
        </Grid>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
          }}
        >
          <Button
            color="primary"
            variant="outlined"
            type="submit"
            disabled={formik.isSubmitting}
          >
            저장
          </Button>
        </Box>
      </Box>
    </div>
  );
};

export default EtcForm;
